import {h, Fragment} from "preact"
import { HistoryElement } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import { popularSearches, HISTORY_DROPDOWN_REC_ID } from "../config"

export default function History() {

    useEffect(() => {
        if(window.nostojs){
            window.nostojs(api => {
                api
                .createRecommendationRequest({ includeTagging: true })
                .setElements([ HISTORY_DROPDOWN_REC_ID ])
                .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [])

    return (
        <div class="ns-autocomplete ns-border-box">

            <div class="ns-autocomplete-section ns-autocomplete-collections">
                <h3>Popular Searches</h3>
                <ul class="ns-keywords-list">
                    {popularSearches.map(item => (
                        <li key={item}>
                            <HistoryElement query={{ query: item }} class="ns-clickable">
                                {item}
                            </HistoryElement>
                        </li>
                    ))}
                </ul>
            </div>

            <div 
                class="nosto_element ns-autocomplete-section ns-autocomplete-products" 
                id={HISTORY_DROPDOWN_REC_ID}
            />
        </div>
    )
}
